import dayjs from 'dayjs';

import { IAttachedVendorQuote } from 'quotes/types';

export const getRowClass = (quote?: IAttachedVendorQuote) => {
  if (!quote) {
    return '';
  }

  const classes = [];

  if (dayjs(quote.validUntil).isBefore(new Date())) {
    classes.push('disabledRow');
  }

  if (1 === quote.archived) {
    classes.push('disabledRow');
  }

  if (quote.quoteQuoteDisaffiliationId) {
    classes.push('disabledRow');
    classes.push('deletedRow');
  }

  return classes.join(' ');
};
